import { FunctionComponent, JSX } from "react";

import CompactContentCard from "@ui/components/content-cards/CompactContentCard";
import { type ContentCardArticle } from "@ui/components/content-cards/content-cards.types";
import ProminentContentCard from "@ui/components/content-cards/ProminentContentCard/ProminentContentCard";
import { type Pattern } from "@ui/components/patterns/patterns.types";

import * as styles from "./ThreeUpAltPattern.css";

type Position = "1" | "2" | "3";

const ThreeUpAltPattern: FunctionComponent<Pattern> = ({
  cardsData,
  gaComponentName = "three_up_alt_pattern",
  className,
}) => {
  const getDesktopCard = (entry: ContentCardArticle, position: Position) => {
    const isFirst = position === "1";
    const contentBlockSize = isFirst ? "large" : "medium";

    return (
      <div className={styles.contentContainer[position]} key={entry.id}>
        <ProminentContentCard
          {...entry}
          componentContext={
            isFirst ? "threeUpAltPatternLargeFirst" : "threeUpAltPatternLarge"
          }
          contentBlockSize={contentBlockSize}
          gaComponentName={gaComponentName}
        />
      </div>
    );
  };

  const getMobileCard = (entry: ContentCardArticle, position: Position) => {
    const isFirst = position === "1";
    const contentBlockSize = isFirst ? "large" : "medium";

    if (isFirst) {
      return (
        <div className={styles.contentContainer[position]} key={entry.id}>
          <ProminentContentCard
            {...entry}
            componentContext="threeUpAltPatternSmall"
            contentBlockSize={contentBlockSize}
            gaComponentName={gaComponentName}
            showBorder
          />
        </div>
      );
    }

    return (
      <div className={styles.contentContainer[position]} key={entry.id}>
        <CompactContentCard
          {...entry}
          componentContext="threeUpPattern"
          contentBlockSize={contentBlockSize}
          gaComponentName={gaComponentName}
          lastChild={position === "3"}
        />
      </div>
    );
  };

  const desktopCards: Array<JSX.Element> = [];
  const mobileCards: Array<JSX.Element> = [];

  cardsData.forEach((entry, index) => {
    const position = index + 1;
    desktopCards.push(getDesktopCard(entry, position.toString() as Position));
    mobileCards.push(getMobileCard(entry, position.toString() as Position));
  });

  return (
    <div className={className}>
      <div className={styles.desktopContainer}>{desktopCards}</div>
      <div className={styles.mobileContainer}>{mobileCards}</div>
    </div>
  );
};

export default ThreeUpAltPattern;
